"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandButton = void 0;
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
var messages = __importStar(require("../translations"));
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var design_system_buttons_1 = require("@contrast-security-inc/design-system-buttons");
var expandButtonContainerCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  padding-left: calc(var(--table-edge-cell-padding) - 8px); /* need to adjust for the icon width */\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  padding-left: calc(var(--table-edge-cell-padding) - 8px); /* need to adjust for the icon width */\n"])));
var ExpandButton = function (_a) {
    var testId = _a.testId, onClick = _a.onClick, _b = _a.isExpanded, isExpanded = _b === void 0 ? false : _b;
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    return (react_1.default.createElement("div", { className: expandButtonContainerCss },
        react_1.default.createElement(design_system_buttons_1.IconButton, { "data-testid": testId, onClick: function (event) {
                onClick();
                // mark the event handled so that the row click doesn't fire
                event.preventDefault();
            }, "aria-label": formatMessage(messages, isExpanded ? 'collapse' : 'expand'), "aria-expanded": isExpanded, Icon: isExpanded ? design_system_foundations_1.IconCaretDown : design_system_foundations_1.IconCaretRight })));
};
exports.ExpandButton = ExpandButton;
var templateObject_1;
